<template>
  <div class="field">
    <span v-if="label"><strong>{{ label }}: </strong></span>
    <div class="p-inputgroup" :class="{ 'mt-2': label }">
      <Dropdown
        :modelValue="modelValue"
        @update:modelValue="$emit('update:modelValue', $event)"
        :options="subgrupos"
        optionLabel="nombre"
        dataKey="id"
        :filter="true"
        :placeholder="placeholder"
        :loading="cargando"
      >
        <template #option="slotProps">
          <div class="p-dropdown-car-option">
            <span>{{ slotProps.option.nombre }} </span>
          </div>
        </template>
      </Dropdown>
      
      <Button
        v-if="permitirCrear"
        class="p-button-info"
        icon="pi pi-plus"
        @click="abrirModalSubGrupo"
        v-tooltip.top="'Crear Nuevo SubGrupo'"
      />
    </div>

    <!-- Modal Integrado para Crear SubGrupo -->
    <SubGrupoCreate 
      :show="mostrarModalSubGrupo" 
      :subgrupo="subgrupoParaModal"
      @closeModal="cerrarModalSubGrupo" 
      @actualizarListado="alCrearSubGrupo"
    />
  </div>
</template>

<script>
import SubGrupoService from "@/service/SubGrupoService";
import { useAuth } from "@/stores";
import SubGrupoCreate from "@/module/subgrupos/SubGrupoCreate.vue";

export default {
  name: 'ZapiSubGrupoDropdown',
  components: { SubGrupoCreate },
  props: {
    label: { type: String, default: 'SUB-GRUPO' },
    modelValue: { type: [Object, String, Number], default: null },
    placeholder: { type: String, default: 'Seleccione un subgrupo' },
  },
  emits: ['update:modelValue', 'onAdd'],
  data() {
    return {
      subgrupos: [],
      cargando: false,
      auth: null,
      subgrupoService: null,
      mostrarModalSubGrupo: false,
      subgrupoParaModal: {}
    }
  },
  computed: {
    permitirCrear() {
      if (!this.auth || !this.auth.user || !this.auth.user.permissions) return false;
      return 'SubGrupo Crear' in this.auth.user.permissions;
    }
  },
  created() {
    this.subgrupoService = new SubGrupoService();
    this.auth = useAuth();
  },
  mounted() {
    this.cargarSubGrupos();
  },
  methods: {
    cargarSubGrupos() {
      this.cargando = true;
      this.subgrupoService.getSubGrupoAll().then(response => {
        const rawSubGrupos = response.subgrupos ? response.subgrupos : (response.data ? response.data : response);
        this.subgrupos = Array.isArray(rawSubGrupos) ? rawSubGrupos.filter(g => g.estado != 0 && g.nombre !== 'NO DEFINIDO') : [];
      }).catch(err => {
        console.error("Error al cargar subgrupos:", err);
      }).finally(() => {
        this.cargando = false;
      });
    },
    recargar() {
      this.cargarSubGrupos();
    },
    abrirModalSubGrupo() {
      this.subgrupoParaModal = {
        estado: { label: "ACTIVO", value: 1 },
      };
      this.mostrarModalSubGrupo = true;
    },
    cerrarModalSubGrupo() {
      this.mostrarModalSubGrupo = false;
    },
    alCrearSubGrupo() {
      this.cargarSubGrupos();
      this.cerrarModalSubGrupo();
    }
  }
}
</script>
